// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___2g0l2","links":"links___2jeZy","submit":"submit___1SE1I"};